import { render, staticRenderFns } from "./DappDetailedTokensContent.vue?vue&type=template&id=2f2e2b8f&scoped=true"
import script from "./DappDetailedTokensContent.vue?vue&type=script&lang=ts"
export * from "./DappDetailedTokensContent.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedTokensContent.vue?vue&type=style&index=0&id=2f2e2b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e2b8f",
  null
  
)

export default component.exports